import {LOGIN_USER, LOGOUT_USER} from '../actions';
import {AuthModel, AuthModelActions} from '../mappers/AuthTypesMapper';
import produce, {Draft} from 'immer';
export const initialAuthState: AuthModel = {
  token: '',
  isAuthenticated: false
};

export const authReducer = produce(
  (state: Draft<AuthModel>, action: AuthModelActions) => {
    switch (action.type) {
      case LOGOUT_USER:
        state.token = '';
        state.isAuthenticated = false;
        break;
      case LOGIN_USER:
        state.token = action.payload?.token || "";
        state.isAuthenticated = true;
        break;
      default:
        break;
    }
  },
  initialAuthState
);
